module.exports = __webpack_public_path__ + "static/media/28.9fb9485b.jpg";